// @flow
import { neoUIColors } from 'common/enums/ColorEnum';

// These styles specific to `react-select` and which overrides the default styles.
const selectSyles: $FixMe = {
    control: base => {
        return {
            ...base,
            font: 'inherit',
            fontSize: 14,
            color: neoUIColors.grey300.code,
            backgroundColor: neoUIColors.grey700.code,
            border: `1px solid ${neoUIColors.grey600.code}`,
            minHeight: 32,
            boxShadow: 'none',
            '&:hover': {
                border: `1px solid ${neoUIColors.grey500.code}`
            }
        };
    },
    input: base => {
        return {
            ...base,
            font: 'inherit',
            color: 'white',
            '& input::selection': {
                color: 'black',
                background: 'white'
            }
        };
    },
    menu: base => {
        return {
            ...base,
            zIndex: 20
        };
    }
};

export default selectSyles;
